var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPeopleWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/ic-people-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/ic-people-white",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_people-white"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounds-copy-9",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.625,36.75 C47.1822995,36.75 52.5,31.4143343 52.5,24.875 C52.5,18.3356657 47.1643343,13 40.625,13 C34.0856657,13 28.75,18.3356657 28.75,24.875 C28.75,31.4143343 34.0856657,36.75 40.625,36.75 Z M40.625,18 C44.4190313,18 47.5,21.0809687 47.5,24.875 C47.5,28.6690313 44.4190313,31.75 40.625,31.75 C36.8309687,31.75 33.75,28.6690313 33.75,24.875 C33.75,21.0809687 36.8309687,18 40.625,18 Z",
    id: "Shape",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5653117,55.3197281 C58.0521078,50.6615648 55.4479894,46.6768709 52.0344828,43.7959184 C48.4978085,40.8214286 44.3452953,39.25 39.9992328,39.25 C35.6531703,39.25 31.5006572,40.8214286 27.9639828,43.7959184 C24.5328808,46.6768709 21.9287624,50.6615648 20.4331539,55.3197281 C19.6061703,57.8826534 19.9756736,60.7074833 21.4360914,62.8775514 C22.7029598,64.7482997 24.585667,65.8333337 26.6267328,65.8333337 L53.4069236,65.8333337 C55.4479894,65.8333337 57.3306966,64.7482997 58.597565,62.8775514 C60.022792,60.7074833 60.3922953,57.8826534 59.5653117,55.3197281 Z M54.2593474,59.1228814 C53.6044785,59.9926405 52.6450194,60.5 51.6246422,60.5 L28.4453278,60.5 C27.4249506,60.5 26.480721,59.9926405 25.8106226,59.1228814 C24.988229,58.0211864 24.7750159,56.5715879 25.2471307,55.2379572 C26.4045735,52.0198483 28.4148688,49.280107 31.0343445,47.308653 C33.6842793,45.308207 36.8063289,44.25 40.034985,44.25 C43.2636411,44.25 46.3856907,45.308207 49.0356255,47.308653 C51.6551012,49.280107 53.650167,52.0198483 54.8228393,55.2379572 C55.2949541,56.5715879 55.081741,58.0211864 54.2593474,59.1228814 Z",
    id: "Shape",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPeopleWhite);
export default __webpack_public_path__ + "static/media/ic-people-white.ec9050f5.svg";
export { ForwardRef as ReactComponent };